import React from 'react';
import { Sheet } from 'react-modal-sheet';
import { ReactComponent as CloseIcon } from '../../../../../Assets/AU/icon-close.svg';
import styles from './index.module.css';

const errorIcon = '/assets/icons/error-exclamation.svg';

interface ConsentErrorSheetProps {
  visible: boolean;
  onClose: () => void;
  onRetry?: () => void;
  description?: string;
  showRetry?: boolean;
  isLoading?: boolean;
}

const ConsentErrorSheet: React.FC<ConsentErrorSheetProps> = ({
  visible,
  onClose,
  onRetry,
  description = 'Apologies for the technical issues. Please retry fetching credit information again.',
  showRetry = true,
  isLoading = false,
}) => {
  return (
    <Sheet isOpen={visible} onClose={onClose} detent="content-height">
      <Sheet.Container className={styles.sheetContainer}>
        <Sheet.Content className={styles.sheetContent}>
          <div className={styles.errorSheetContainer}>
            {/* Close button */}
            <button
              className={styles.closeButton}
              onClick={onClose}
              disabled={isLoading}
              aria-label='Close'
            >
              <CloseIcon />
            </button>
            {/* Content */}
            <div className={styles.content}>
              {/* Error Icon */}
              <div className={styles.iconContainer}>
                <img src={errorIcon} alt="Error" width="35" height="35" />
              </div>

              {/* Error Message */}
              <div className={styles.errorTitle}>Something went wrong!</div>
              <div className={styles.errorDescription}>
                {description}
              </div>
            </div>

            {/* Button */}
            <div className={styles.buttonContainer}>
              <button
                className={styles.retryButton}
                onClick={showRetry ? onRetry : onClose}
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className={styles.spinner} aria-label='Loading' />
                ) : showRetry ? (
                  'Retry'
                ) : (
                  'Close'
                )}
              </button>
            </div>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop className={styles.sheetBackdrop} onTap={onClose} />
    </Sheet>
  );
};

export default ConsentErrorSheet;
